import { stringify } from 'qs';
import request from '@/utils/request';

// 获取portal下的登陆log记录
export async function qryLoginLogs(params) {
  return request('/logs/login', {
    method: 'POST',
    body: params,
  });
}

// 获取日志事件源list
export async function qryLogEventsOrigin() {
  return request('/logs/event/src');
}

// 获取日志事件类型list
export async function qryLogEventsType() {
  return request('/logs/event/type?eventSrcCode=');
}

// 获取portal下的系统log记录
export async function qrySysLogs(params) {
  return request('/logs/system', {
    method: 'POST',
    body: params,
  });
}

// 获取portal下的审计log记录
export async function qryAuditLogs(params) {
  return request('/logs/audit', {
    method: 'POST',
    body: params,
  });
}

export async function qryPortals() {
  return request('/portals');
}

export async function qryUsers(params) {
  return request(`/users?${stringify(params)}`);
}
